import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
/**
 * 屋根ー辺の設定ダイアログ（軒 or 妻）
 */
class RoofSideSetting extends Dialog {
    _type: number;

    set type(numType) {
      this._type = numType;

      // 選択中の言語にチェック
      this.setCheckSelected();
    }

    get type() {
      return this._type;
    }

    index: number;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ダイアログのコンテンツ生成
      const id = 'ketaDialog';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = '桁線設定'; break;
        default: title = 'Roof Line Setting'; break;
      }

      let contents = '';
      contents += '<div class="p-changeKetaBox">';
      contents += '<ul class="p-changeKetaRadios js-changeKetaRadios">';
      contents += '<li><input type="radio" name="radioKeta" id="radioKetaNoki" value="0"><label for="radioKetaNoki"><span class="jp">軒</span><span class="en">Noki</span></label></li>';
      contents += '<li><input type="radio" name="radioKeta" id="radioKetaTsuma" value="1"><label for="radioKetaTsuma"><span class="jp">妻</span><span class="en">Tsuma</span></label></li>';
      contents += '</ul>';
      contents += '</div>';

      let footer = '';
      footer += '<button id="btnApplyKeta" value="1"><span class="jp">適用する</span><span class="en">Apply</span></button>\n';
      footer += '<button id="btnCancelKeta" value="0"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>\n';

      this.createDialog(id, title, contents, footer);

      // イベント設置
      this.setEvents();
    }

    /**
     * 設定言語からラジオボタンにチェック
     */
    setCheckSelected() {
      const self = this;
      const val = (<HTMLInputElement>document.getElementById('radioKetaNoki')).value;
      if (Number(val) === Number(self.type)) {
        (<HTMLInputElement>document.getElementById('radioKetaNoki')).checked = true;
      } else {
        (<HTMLInputElement>document.getElementById('radioKetaTsuma')).checked = true;
      }
    }

    /**
     * イベント設置
     */
    setEvents() {
      const self = this;
      document.getElementById('btnApplyKeta').addEventListener('click', self.onBtnChangeClicked);
      document.getElementById('btnCancelKeta').addEventListener('click', self.onBtnCancelClicked);
    }

    /**
     * キャンセルボタンがクリックされた
     */
    onBtnCancelClicked = (e) => {
      e.preventDefault();
      this.close();
    }

    /**
     * 変更ボタンがクリックされた
     */
    onBtnChangeClicked = (e) => {
      e.preventDefault();

      const self = this;
      let value;
      if ((<HTMLInputElement>document.getElementById('radioKetaNoki')).checked === true) {
        value = (<HTMLInputElement>document.getElementById('radioKetaNoki')).value;
        console.log(value);
      } else {
        value = (<HTMLInputElement>document.getElementById('radioKetaTsuma')).value;
      }
      // 該当Indexの設定を変更する
      (marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Roof).onChangeSideSetting(this.index, value);

      self.close();
    }
}
export default RoofSideSetting;
